import React, { useState, createContext, useEffect } from 'react'

interface ThemeProviderProps {
  isDarkMode: boolean
  setDarkMode: (isDarkMode: boolean) => void
  children?: React.ReactNode
}

export const ThemeContext = createContext<ThemeProviderProps>({
  isDarkMode: false,
  setDarkMode: () => void 0,
  children: null
})

export const darkModePreferred = localStorage.getItem('darkModePreferred') == 'true' // explicit shallow equal

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [ isDarkMode, setDarkMode ] = useState(darkModePreferred)

  useEffect(() => {
    localStorage.setItem('darkModePreferred', isDarkMode.toString())
  }, [ isDarkMode ])

  return (
    <ThemeContext.Provider value={{ isDarkMode, setDarkMode, children }}>
      {children}
    </ThemeContext.Provider>
  )
}
